// extracted by mini-css-extract-plugin
module.exports = {"container":"_1f3AYS","content":"_1rq18I","closeIcon":"_2zjqe7","subTitle":"_xcNBU"};